<template>
  <v-expansion-panels accordion flat>
    <v-expansion-panel
      v-for="(item, index) in items"
      :key="index"
      :class="{
        'no-borders': !hasBorders
      }"
      :data-cy="item.dataCyRow"
    >
      <v-expansion-panel-header class="px-0" @click="$emit('accordion-click', item.title)">
        <UlSwitch
          v-if="item.switch"
          :disabled="item.switch.disabled"
          :value="!!switchValues[item.identifier]"
          :data-cy="item.dataCy"
          @input="$emit('change', item.identifier, $event)"
        />
        <h6 :class="{ 'pl-6': item.switch }" class="mr-2">{{ item.title }}</h6>
        <template #actions>
          <div class="grey-lighten rounded-circle pa-2">
            <v-icon size="24" color="black">$dropSmall</v-icon>
          </div>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="mx-n4 mx-xl-n8">
        <p
          v-for="(s, i) in normalizeSubtitle(item.subtitle)"
          :key="'s' + i"
          class="mb-2"
          v-html="addNbsp(s)"
        />
        <ul v-if="item.body !== undefined" class="pl-2">
          <li
            v-for="(itemBody, idx) in item.body"
            :key="idx"
            class="mb-1 pl-4"
            v-html="addNbsp(itemBody)"
          ></li>
        </ul>
        <div v-else :data-cy="item.dataCyBodyText" v-html="addNbsp(item.bodyText)"></div>
        <p v-if="item.footer" class="mt-4" v-html="addNbsp(item.footer)" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'CollapseList',
  props: {
    items: {
      type: Array,
      required: true
    },
    switchValues: {
      type: Object,
      default: () => {}
    },
    hasBorders: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    normalizeSubtitle(subtitle) {
      if (!subtitle) {
        return [];
      }
      return Array.isArray(subtitle) ? subtitle : [subtitle];
    }
  }
};
</script>


<style lang="scss" scoped>
ul {
  list-style: none;

  > li {
    position: relative;

    &::before {
      content: '';
      display: block;
      background-color: $black;
      position: absolute;
      left: 0;
      top: 9px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
  }
}
</style>
